// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./assets/drawing.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "* {\n  font-family: 'Andika', sans-serif;\n}\n\n.App_monaco-editor_onmWg, .App_monaco-editor_onmWg * {\n   font-family: 'JetBrains Mono', 'Consolas', 'Monaco', monospace !important;\n}\n\nhtml, body, #App_root_3HT6m {\n  height: 100%;\n  margin: 0;\n}\n\n.App_custom-font-title_21kw8 {\n  font-family: \"Kavivanar\", cursive;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.App_animated-background_2HnIy {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n", ""]);
// Exports
exports.locals = {
	"monaco-editor": "App_monaco-editor_onmWg",
	"monacoEditor": "App_monaco-editor_onmWg",
	"root": "App_root_3HT6m",
	"custom-font-title": "App_custom-font-title_21kw8",
	"customFontTitle": "App_custom-font-title_21kw8",
	"animated-background": "App_animated-background_2HnIy",
	"animatedBackground": "App_animated-background_2HnIy"
};
module.exports = exports;
